<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.792 17.384C15.672 15.992 17.16 13.352 17.16 11.816C16.968 11.96 16.584 12.056 16.152 12.056C14.136 12.056 12.792 10.52 12.792 8.552C12.792 6.68 14.184 5 16.536 5C18.936 5 20.76 7.256 20.76 10.184C20.76 14.936 17.64 18.296 14.136 19.88L12.792 17.384ZM3 17.384C5.928 15.992 7.416 13.352 7.416 11.816C7.224 11.96 6.84 12.056 6.36 12.056C4.392 12.056 3.048 10.52 3.048 8.552C3.048 6.68 4.392 5 6.792 5C9.192 5 11.016 7.256 11.016 10.184C11.016 14.936 7.896 18.296 4.392 19.88L3 17.384Z"
    />
  </svg>
</template>
